import {Component, Input} from '@angular/core';
import { IconComponent } from '../../../../elements/icon/icon.component';
import { Icon, Icons } from '../../../../../model/icon';
import {NgClass} from '@angular/common';
import {ImagesScrollComponent} from '../../../../elements/images-scroll/images-scroll.component';
import {ImageSlide} from '../../../../../model/imageSlide';

@Component({
  selector: 'app-images-slider-section',
  imports: [IconComponent, NgClass, ImagesScrollComponent],
  templateUrl: './images-slider-section.component.html',
  styleUrls: ['./images-slider-section.component.scss']
})
export class ImagesSliderSectionComponent {
  @Input() imagesCards: ImageSlide[] = [];

  iconLeft: Icon = Icons.arrow;
  iconRight: Icon = Icons.arrowRight;

  images: string[] = [
    '/app/assets/images/hockey.jpeg',
    '/app/assets/images/test.jpeg',
    '/app/assets/images/hockey.jpeg',
    '/app/assets/images/test.jpeg'
  ];

  currentIndex: number = 0;
  animationClass: string = '';

  mouseOver(left: boolean) {
    if (left) {
      this.iconLeft = Icons.arrowGold; // Иконка при наведении на левую стрелку
    } else {
      this.iconRight = Icons.arrowGoldRight; // Иконка при наведении на правую стрелку
    }
  }

  mouseLeave() {
    this.iconLeft = Icons.arrow; // Возврат к исходной иконке
    this.iconRight = Icons.arrowRight; // Возврат к исходной иконке
  }

  turnLeft() {
    this.animationClass = 'slide-out-right'; // Анимация для выхода
    setTimeout(() => {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.animationClass = 'slide-in-left'; // Анимация для входа
    }, 300); // Длительность анимации
  }

  turnRight() {
    this.animationClass = 'slide-out-left'; // Анимация для выхода
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.animationClass = 'slide-in-right'; // Анимация для входа
    }, 300); // Длительность анимации
  }

  protected readonly Icons = Icons;
  protected readonly scroll = scroll;
}
